import { render, staticRenderFns } from "./transfercourseManage.vue?vue&type=template&id=6525ea3e&"
import script from "./transfercourseManage.vue?vue&type=script&lang=js&"
export * from "./transfercourseManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports